import PropTypes from "prop-types";
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FormattedHTMLMessage, useIntl } from 'gatsby-plugin-intl';
import { PARTNER_COUNTRY } from '../../utils/constants';
// import { Link } from "gatsby";

export default function Footer({setPopoverVisible}) {
  const intl = useIntl();
  const [samsungCareLink, setSamsungCareLink] = useState(process.env.GATSBY_SAMSUNG_CARE_PLUS_URL)
  const [samsungPrivacyPolicy, setSamsungPrivacyPolicy] = useState(process.env.GATSBY_PRIVACY_POLICY_BE)
  const isChineseCountry = () => {
    return ['HK', 'TW', 'MO'].includes(process.env.GATSBY_COUNTRY)
  }
  const isBelgium = () => process.env.GATSBY_COUNTRY === 'BE'
  const isSwitzerland = () => process.env.GATSBY_COUNTRY === 'CH'

  useEffect(() => {
    const samsungPrivacyPolicyLink = isChineseCountry() && intl.locale === 'en' ? process.env.GATSBY_PRIVACY_POLICY_EN_BE : process.env.GATSBY_PRIVACY_POLICY_BE
    const samsungBelgiumPrivacyPolicyLink = isBelgium && intl.locale === 'fr-be' ? process.env.GATSBY_PRIVACY_POLICY_BE_FR : process.env.GATSBY_PRIVACY_POLICY_BE_NL
    const samsungSwitzerlandPrivacyPolicyLink = isSwitzerland
      ? {
          de: process.env.GATSBY_PRIVACY_POLICY_BE_DE,
          fr: process.env.GATSBY_PRIVACY_POLICY_BE_FR,
          it: process.env.GATSBY_PRIVACY_POLICY_BE_IT,
          en: process.env.GATSBY_PRIVACY_POLICY_BE_EN,
        }[intl.locale]
      : process.env.GATSBY_PRIVACY_POLICY_BE_DE;
    const samsungCareplusLink = isChineseCountry() && intl.locale === 'en' ? process.env.GATSBY_SAMSUNG_CARE_PLUS_EN_URL : process.env.GATSBY_SAMSUNG_CARE_PLUS_URL
    setSamsungCareLink(samsungCareplusLink)
    if (process.env.GATSBY_REGION === 'ASIA') {
      // ASIA region
      setSamsungPrivacyPolicy(samsungPrivacyPolicyLink);
    } else if (isBelgium()) {
      // Only Belgium
      setSamsungPrivacyPolicy(samsungBelgiumPrivacyPolicyLink);
    } else if (isSwitzerland()) {
      setSamsungPrivacyPolicy(samsungSwitzerlandPrivacyPolicyLink);
    } else if (process.env.GATSBY_REGION !== 'ASIA' && (!isBelgium()|| !isSwitzerland())) {
      // Not ASIA & Not Belgium / Switzerland
      setSamsungPrivacyPolicy(samsungPrivacyPolicyLink);
    }

  }, [])

  const isPopoverRequired = () => {
    return process.env.GATSBY_COUNTRY === PARTNER_COUNTRY.HK || process.env.GATSBY_COUNTRY === PARTNER_COUNTRY.MO
  }

  return (
    <Row className='footer'>
      <Col md="8" xs="16" className={`mb-1 mt-1 container__body `}>
        <FormattedHTMLMessage id="footerText" />
      </Col>
      <Col md="4" xs="16" className={`mt-1 container__copyright `} style={{textAlign:"end"}} >
        <span >
          <a href={samsungCareLink} target="_blank" rel='noreferrer'> {intl.formatMessage({id: "whatisSamsung"})}</a> | {isPopoverRequired() && (<a onClick={setPopoverVisible} target="_blank" rel='noreferrer'> {intl.formatMessage({id: "terms"})} |</a> )} <a href={samsungPrivacyPolicy} target="_blank" rel='noreferrer'>{intl.formatMessage({id: "privacy"})}</a> 
          {/* {process.env.GATSBY_COUNTRY === PARTNER_COUNTRY.MY && 
            <>| {' '} 
              <Link
                to={`/${intl.locale}/faqs/migration`}
                activeClassName="active"
              >
                {intl.formatMessage({ id: "faqs" })}
              </Link>
            </>
          } */}
        </span>
      </Col>
      
    </Row>
  )
}

Footer.propTypes = {
  setPopoverVisible: PropTypes.func,
};
